import * as React from "react";
export class Cta extends React.Component {
    render() {
        return (React.createElement("a", { href: this.props.url, onClick: (event) => this.props.handler(event), className: "rj-racing-future-events__cta", "data-uat": "view-event-button-future-races" }, this.props.children));
    }
}
//# sourceMappingURL=Cta.js.map